<template>

    <div>
        <a-table :columns="columns" :data-source="tablePurchaseOrders" :loading="tableLoading" :pagination="pagination"
            :scroll="{ x: 1500, y: 600 }" class="tableStyle">

            <!-- <template slot="thumb" slot-scope="">
                <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
            </template> -->
            <template slot="action" slot-scope="data">
                <a-dropdown>
                    <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                        <a-icon style="font-size:25px;" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                        <a-menu-item>
                            <a @click="showD(data)">More Details</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a @click="showDownload(data)">Download</a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </template>
            <template slot="statusLabel" slot-scope='data'>
                <status-component :status="data"></status-component>
            </template>
        </a-table>

        <preview-waybill ref="previewRef"></preview-waybill>
        <waybill-download ref="downloasRef"></waybill-download>

        <!-- Receive Purchase Order Model -->
        <a-modal class="modalStyle" :visible="receiveOrderVisible" width="1000px" :footer="null"
            @cancel="handleReceiveOrderCancel">
            <a-spin :spinning="loading">
                <h3
                    style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                    Receive Purchase Orders</h3>
                <receive-orders-form :data="data" @inventoryRequest="handleAddInventoryTransfer"></receive-orders-form>
            </a-spin>
        </a-modal>
    </div>

</template>
<script>

import moment from 'moment';
// import _ from 'lodash';
// import XLSX from "xlsx";
import { NotificationMixins } from '@/mixins/NotificationMixins'
import PreviewWaybill from '../../warehouse/common/PreviewWaybill.vue';
import WaybillDownload from '../../warehouse/common/WaybillDownload.vue';
import { mapActions } from 'vuex';
// import ReceiveOrdersForm from '../modals/ReceiveOrdersForm.vue'

const columns = [
   
    {
        title: 'Customer Name',
        dataIndex: 'name',
        key: 'name'
        // width: 150,
    },
    {
        title: 'Credit Note #',
        dataIndex: 'creditNote',
        key: 'creditNote'

        // width: 150,
    },
    {
        title: 'Reference #',
        dataIndex: 'reference',
        key: 'reference',
        // width: 150,
    },

    {
        title: 'Credit Note Date',
        dataIndex: 'creditDATE',
        key: 'creditDATE',
        // width: 150,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity'
        // width: 150,
    },
    {
        title: 'Item',
        dataIndex: 'item',
        key: 'item'
        // width: 150,
    },
    {
        title: 'Salesperson',
        dataIndex: 'salesPerson',
        key: 'salesPerson'
        // width: 150,
    },
];

const tablePurchaseOrders = [
    {
        id: 1,
        key: 1,
        name: 'Fuseini Ayambilla',
        creditNote: 'CN-6568',
        reference: 'R-6568',
        creditDATE: '14-03-2024',
        quantity: '9',
        item: 'Aliseryl WS (1kg)',
        salesPerson: 'SO-35532'
    },
    {
        id: 2,
        key: 2,
        name: 'Fuseini Ayambilla',
        creditNote: 'CN-6568',
        reference: 'R-6568',
        creditDATE: '14-03-2024',
        quantity: '9',
        item: 'Aliseryl WS (1kg)',
        salesPerson: 'SO-35532'
    },
    {
        id: 3,
        key: 3,
        name: 'Fuseini Ayambilla',
        creditNote: 'CN-6568',
        reference: 'R-6568',
        creditDATE: '14-03-2024',
        quantity: '9',
        item: 'Aliseryl WS (1kg)',
        salesPerson: 'SO-35532'
    }
]


import StatusComponent from '../../shared-components/StatusComponent.vue'
export default {
    name: "AllCreditNotesTable",
    props: ['notes'],
    mixins: [NotificationMixins],
    components: {
        StatusComponent,
        PreviewWaybill,
        WaybillDownload
    },
    data() {
        return {
            tablePurchaseOrders, //this.purchaseOrdersData,
            tableLoading: false,
            receiveOrderVisible: false,
            loading: false,
            columns,
            data: {},
            pagination: {
                pageSize: 20
            }
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'addStockToWarehouse']),
        handleReceiveOrderCancel() {
            this.receiveOrderVisible = false
        },
        cancelPurchaseOrder(data) {
            const request = {
                status: 4,
                id: data.id
            }
            this.$emit('orderStatus', request)
        },
        completedOrder(data) {
            const request = {
                status: 3,
                id: data.id
            }
            this.$emit('orderStatus', request)
        },

        markAsSend(data) {
            const request = {
                status: 1,
                id: data.id
            }
            this.$emit('orderStatus', request)
        },
        showReceiveModal(data) {
            this.data = data
            this.receiveOrderVisible = true
        },
        showMoreDetails(data) {
            // console.log("data | ", data)
            const purchaseOrders = data.purchaseOrderLines.map(order => ({
                key: order.id,
                id: order.id,
                productId: order.productId,
                name: order.productName,
                category: order.categoryName ? order.categoryName : "",
                quantity: order.quantity.toString(),
                unitPrice: order.price.toString(),
                lineTotal: (parseInt(order.quantity) * parseFloat(order.price)).toFixed(2)
            }))
            let previewData = {
                discount: data.discount,
                purchaseOrderId: data.id,
                deliveryDate: moment(data.deliveryDate).format(),
                supplierName: data.supplierName,
                supplierId: data.supplierId,
                supplierAddress: data.supplierAddress,
                supplierCity: '',
                supplierCountry: '',
                destionation: '',
                sellerAddress: data.sellerAddress,
                shipCity: '',
                shipCountry: '',
                shippingMethodLabel: data.shippingMethodLabel,
                shippingMethod: data.shippingMethod,
                shippinTerm: data.terms,
                tableData: purchaseOrders,
                action: "edit",
                statusLabel: data.statusLabel,
                deleiveries: data.inventoryDeliveries
            }
            // console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push({
                name: 'purchase-order-invoice'
            }).catch(() => { })
        },
        showCancelActions(data) {
            const allowedStatus = ['Draft', 'Pending']
            const result = allowedStatus.includes(data.statusLabel) ? true : false
            return result
        },
        showReceiveActions(data) {
            const allowedStatus = ['Receiving', 'Pending']
            const result = allowedStatus.includes(data.statusLabel) ? true : false
            return result
        },
        showCompletedActions(data) {
            const allowedStatus = ['Receiving']
            const result = allowedStatus.includes(data.statusLabel) ? true : false
            return result
        },
        showMarkAsSendActions(data) {
            const allowedStatus = ['Draft']
            const result = allowedStatus.includes(data.statusLabel) ? true : false
            return result
        },
        async handleAddInventoryTransfer(data) {
            this.loading = true;
            const response = await this.addStockToWarehouse(data);
            this.loading = false;
            if (response.status === 200) {
                this.receiveOrderVisible = false
                this.showSuccessAlert("Purchase Order Received Successfully");
                this.$emit('orderData', true)
            } else {
                // // console.log("Error | ", response);
                this.showErrorAlert(response.data.messages);
            }

        },

        showPreview(data) {
            // console.log("data | ", data)
            const waybillInfo = {
                requestId: data.requestId,
                fulfillmentLines: data.fulfillmentLines.map(product => ({
                    productBrandName: product.productBrandName,
                    quantity: product.quantity,
                    productId: product.productId,
                    key: product.productId
                })),
                expectedAt: moment(data.expectedAt).format("DD-MMM-YYYY"),
                destinationLocationName: data.request.destinationLocationName,
                requestedBy: data.request.requestedBy,
                sourceLocationName: data.request.sourceLocationName
            }
            this.$refs.previewRef.showPreviewData(waybillInfo);
        },
        showDownload(data) {
            const waybillInfo = {
                requestId: data.requestId,
                fulfillmentLines: data.fulfillmentLines.map(product => ({
                    productBrandName: product.productBrandName,
                    quantity: product.quantity,
                    productId: product.productId,
                    key: product.productId
                })),
                expectedAt: moment(data.expectedAt).format("DD-MMM-YYYY"),
                destinationLocationName: data.request.destinationLocationName,
                requestedBy: data.request.requestedBy,
                sourceLocationName: data.request.sourceLocationName
            }
            this.$refs.downloasRef.downloadWaybill(waybillInfo);
        },
    },
    computed: {

    },
    watch: {
        notes: {
            immediate: true,
            handler() {
                // this.tablePurchaseOrders = newValues
            }

        }
    }
}
</script>

<style  scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.customerTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.customerTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.customerTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.customerTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.orderTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.orderTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}


.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>